import {configureStore} from '@reduxjs/toolkit'
import { mainSlice } from "./mainSlice";
import { attachmentSlice } from './attachmentsSlice';

export const store = configureStore({
    reducer:{
        mainSlice: mainSlice.reducer,
        attachmentSlice: attachmentSlice.reducer
    }
})